const CClassFormat = {
  ALL: "",
  ONLINE: "online",
  IN_PERSON: "inPerson",
  KITS: "kits"
};

export default CClassFormat;
